// Company owns a finite set of subpages; nested provider routes are added
// explicitly by their feature, never inferred from an arbitrary path segment.
export const COMPANY_SUBPAGES = Object.freeze(['overview', 'connections', 'members']);
export function companySubpage(route, { onboardingContinuation = false } = {}) {
  const rest = Array.isArray(route?.rest) ? route.rest : [];
  if (isCompanyZapierRoute(route)) return 'connections';
  if (rest.length === 0) return onboardingContinuation ? 'connections' : 'overview';
  return rest.length === 1 && COMPANY_SUBPAGES.includes(rest[0]) ? rest[0] : 'overview';
}

export function isCompanyZapierRoute(route) {
  return route?.rest?.length === 2 && route.rest[0] === 'connections' && route.rest[1] === 'zapier';
}
